module.exports = __webpack_public_path__ + "static/media/3-a.de1e41cd.png";